import { formatApiDateRangeDisplay } from '#/utils/date';

/**
 * UI range DatePicker ↔ listQuery.filters（API：`issue_date_from`／`issue_date_to`）。
 */
export function readIssueDateRangeFilter(filters = {}) {
  const from = filters.issueDateFrom;
  const to = filters.issueDateTo;

  if (!from && !to) {
    return undefined;
  }

  return {
    from: from ?? '',
    to: to ?? from ?? '',
  };
}

export function applyIssueDateRangeToFilters(filters = {}, range) {
  const next = { ...filters };

  if (!range?.from && !range?.to) {
    delete next.issueDateFrom;
    delete next.issueDateTo;
    return next;
  }

  const from = range.from;
  const to = range.to || range.from;

  // TODO: 單日 API 契約未確認 — 起迄同日時是否僅送 issue_date_from（勿猜新參數名）
  next.issueDateFrom = from || undefined;
  next.issueDateTo = to || undefined;

  return next;
}

export function resolveIssueDateFilterChipDisplay(_values, ctx = {}) {
  const display = formatApiDateRangeDisplay({
    from: ctx.filters?.issueDateFrom,
    to: ctx.filters?.issueDateTo,
  });

  return display ? [display] : [];
}
